import { lazy } from "react";

export const PageViewSpecialty = lazy(() => import("./component/Container"));
